angular.module('stack.common.storage.services.StorageStrategyService', [
  'stack.common.storage.services.LocalStorageService',
  'stack.common.storage.services.CookieStorageService'
])

/**
 * The StorageStrategyService service abstracts the storage process. One of two storage
 * solutions is provided depending upon provided browser features (i.e., Local
 * and Cookies).
 *
 * @class StorageStrategyService
 * @constructor
 * @module stack.common.storage.StorageStrategyService
 */
.factory('StorageStrategyService', [
  '$window',
  'LocalStorageService',
  'CookieStorageService',
  function ($window, LocalStorageService, CookieStorageService) {
    'use strict';

    var service = {
      /**
       * Property houses storage strategy.
       *
       * @property strategy
       * @type Object
       */
      strategy: undefined,

      /**
       * Method returns storage implementation.
       *
       * @return {Object} Storage implementation
       */
      getStrategy: function getStrategy() {
        return service.strategy;
      },

      /**
       * Method sets the storage implementation.
       *
       * @param {string} strategy - Type of storage approach (i.e., local or cookie)
       */
      setStrategy: function setStrategy(strategy) {
        var strategyTemporary = !strategy ? 'local' : strategy;
        strategyTemporary = strategyTemporary.toLowerCase();
        if (strategyTemporary === 'local') {
          service.strategy = LocalStorageService;
        } else if (strategy === 'cookie') {
          service.strategy = CookieStorageService;
        }
      },

      /**
       * Method checks the $window object for the localStorage property.
       *
       * @return {boolean} browser support for location storage
       */
      hasLocalStorage: function hasLocalStorage() {
        var feature = false;
        try {
          $window.localStorage.setItem('detect', 'detect');
          $window.localStorage.removeItem('detect');
          feature = true;
        } catch (e) {
          feature = false;
        }

        return feature;
      },

      /**
       * Method checks cookie support.
       *
       * @return {boolean} browser support for cookies
       */
      hasCookies: function hasCookies() {
        return navigator.cookieEnabled;
      },

      /**
       * Method executes initialization process.
       */
      initialize: function initialize() {
        var local = service.hasLocalStorage();
        var cookies = service.hasCookies();

        // Set storage strategy.
        if (local) {
          service.setStrategy('local');
        } else if (cookies) {
          service.setStrategy('cookie');
        }
      }
    };

    // Initailize.
    service.initialize();

    return service;
  }
]);
